<template>
  <div :class="$style.declaration">
    <div :class="$style.content">
      <div
        :class="$style.codeBtn"
        @click="handleClick(1,select)"
        v-if="dataList && dataList.length<31"
        style="margin-bottom: 10px;">
        {{ $t('common.Declare') }}
      </div>
      <common-title>{{ $t('common.Pleaseselectthefiler') }}</common-title>
      <div :class="$style.Box">

        <div :class="$style.rightBox">
          <!-- <div :class="$style.addBox" @click="handleClick(1,select)" v-if="dataList && dataList.length<10">
            <i class="el-icon-circle-plus-outline"/>
          </div> -->
          <div
            :class="$style.listBox"
            v-for="(item,index) in dataList"
            :key="item.id">
            <div :class="$style.listBoxName">
              {{ $t('common.Filer') }}：{{ item.name }}
            </div>
            <div :class="$style.listBoxIcon">
              <i style="font-size: 25px;" class="el-icon-circle-close" @click.stop="handleDel(index,item)"/>
            </div>
            <div :class="$style.listBoxQRcode">
              <img :src="item.QRcode" width="120"/>
            </div>
            <div
              :class="$style.codeBtn"
              v-if="(item.status !== 6 && item.status !== 3) &&item.remove !== 1"
              @click="handleSaveClick(item.qrCode,item.name)">
              {{ $t('common.saveCode') }}
            </div>
            <div :class="$style.loseCodeBtn" v-if="(item.status === 6 || item.status === 3 )|| item.remove === 1">
              {{ $t('common.failureCode') }}
            </div>
            <div :class="$style.amend" @click="handleClick(2,index,item)">
              {{ $t('common.edit') }}
            </div>
            <!-- <div v-if="item.status === 3 || item.remove === 1" :class="$style.effectiveness">
              {{ $t('common.efficacy') }}
            </div> -->
            <div :class="$style.listBoxButton">
              <!-- {{ new Date(item.time) | time }} -->
              {{ item.submitTime }}
              <!-- {{ new Date(item.createTime.replace(/-/g, '/')) }} -->
            <!-- {{ new Date() | datePick }} -->
            <!-- <el-button
                :type="select === index ? 'primary': null"
                @click="handleSelect(index)">{{ select === index ? '已選擇': '選擇' }}</el-button> -->
            </div>
          </div>

        </div>
      </div>
    <!-- <div :class="$style.buttonBox">
        <el-button type="primary" @click="handleClick(1)">新增</el-button>
        <el-button type="primary" @click="handleClick(2)">編輯</el-button>
        <el-button @click="dialogVisible=true">移除</el-button>
      </div> -->
    </div>
    <el-dialog
      width="30%"
      :title="$t('common.Tips')"
      :visible.sync="dialogVisible"
      append-to-body>
      {{ $t('common.Whethertoconfirmtheremoval') }}
      <template #footer>
        <el-button @click="dialogVisible=false">{{ $t('common.No') }}</el-button>
        <el-button type="primary" @click="handleClick(3)">{{ $t('common.Yes') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import downloadImg from "../../utils/downloadImg";
  import api from "../../api";
  import {
    Button,
    Dialog,
    Message
  } from "element-ui";
  // eslint-disable-next-line no-unused-vars
  // import { time, filters } from "../../filters";
  import filters from "../../filters";
  import { commonTitle } from "./components";
  export default {
    name: "Pc",
    components: {
      "el-dialog": Dialog,
      "el-button": Button,
      commonTitle
    },
    props: {},
    data () {
      return {
        dataList: [],
        select: null,
        dialogVisible: false,
        itemdata: {}
      };
    },
    methods: {
      handleSaveClick (url, userName) {
        const name = `${userName}${filters.Qrcodetime(new Date())}.jpg`;
        downloadImg(url, name);
      },
      handleClick (type, index, val) {
        switch (type) {
        case 1: {
          this.$router.push({
            path: "/eDCBNI/Currency/Declaration"
          });
          break;
        }
        case 2: {
          const $index = this.dataList.findIndex(item => item.id === val.id);
          this.$router.push({
            path: "/eDCBNI/Currency/Declaration",
            query: {
              index: JSON.stringify($index)
              // id: item.id
            }
          });
          break;
        }
        case 3: {
          const pageData = JSON.parse(localStorage.getItem("pageData"));
          const $index = pageData.findIndex(item => item.id === this.itemdata.id);
          if ($index !== -1) {
            pageData.splice($index, 1);
          }
          localStorage.setItem("pageData", JSON.stringify(pageData));
          this.dialogVisible = false;
          Message({
            message: this.$t("common.Thedeletionwassuccessful"),
            type: "success"
          });
          if (JSON.parse(localStorage.getItem("pageData"))) {
            let id = "";
            JSON.parse(localStorage.getItem("pageData")).forEach(item => {
              id += item.id + ",";
            });
            api.getCashInfo(id.substr(0, id.length - 1)).then(res => {
              const arr = JSON.parse(localStorage.getItem("pageData"));
              res.forEach(item => {
                arr.forEach(val => {
                  if (item.id === val.id) {
                    val.status = item.status;
                    val.remove = item.remove;
                  }
                });
              });
              this.dataList = arr.sort((a, b) => {
                return a.submitTime < b.submitTime ? 1 : -1;
              });
              localStorage.setItem("pageData", JSON.stringify(this.dataList));
              // console.log(arr);
              // console.log(this.dataList);
            });
          }
          // this.dataList = JSON.parse(localStorage.getItem("pageData"));
          this.result = 0;

          break;
        }
        }
      },
      handleCookies () {
        switch (this.allowCookis) {
        case true: {
          const obj = {
            ...this.from
          };
          obj.phone = `${this.phoneTitle}-${obj.phone}`;
          delete obj.list;
          localStorage.setItem("pageData", JSON.stringify(obj));
          break;
        }
        case false: {
          localStorage.removeItem("pageData");
          break;
        }
        }
      },
      // handleSelect (index) {
      //   this.select = index;
      // },
      handleDel (index, item) {
        this.select = index;
        this.itemdata = item;
        this.dialogVisible = true;
      }
    },
    created () {
      console.log("修改显示BUG11/5");
      if (JSON.parse(localStorage.getItem("pageData"))) {
        let id = "";
        JSON.parse(localStorage.getItem("pageData")).forEach(item => {
          id += item.id + ",";
        });
        api.getCashInfo(id.substr(0, id.length - 1)).then(res => {
          const arr = JSON.parse(localStorage.getItem("pageData"));
          res.forEach(item => {
            arr.forEach(val => {
              if (item.id === val.id) {
                val.status = item.status;
                val.remove = item.remove;
              }
            });
          });
          this.dataList = arr.sort((a, b) => {
            return a.submitTime < b.submitTime ? 1 : -1;
          });
          localStorage.setItem("pageData", JSON.stringify(this.dataList));
          // console.log(this.dataList);
        });
      }

      // this.dataList = JSON.parse(localStorage.getItem("pageData"));
    }
  };
</script>

<style lang="scss" module src="./style.scss">
</style>
